import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { createSelector } from 'reselect';
import { toggleFallbackModal } from '../../../../../../../slices/modals/reducer';
import FallbackRange from './FallbackRange';
import { saveFallbackImage } from '../../../../../../../slices/campaigns/thunk';

function FallbackImageModal() {
  const dispatch = useDispatch();

  const selectFallbackModalState = createSelector(state => state.Modal, state => state.fallbackModal);
  const modalState = useSelector(selectFallbackModalState);

  function closeModal() {
    dispatch(toggleFallbackModal());
  }

  const selectCreativeState = createSelector(state => state.Campaign, state => state.selectedCreative);
  const selectedCreative = useSelector(selectCreativeState);
  const [fallback, setFallback] = useState((selectedCreative?.fallback || []));
  return (
    <Modal isOpen={modalState} toggle={closeModal} centered size='md'>
      <ModalHeader className='border-bottom p-3' toggle={closeModal}>
        <h6 className='fw-normal m-0'>{selectedCreative !== null ? selectedCreative.size : ""}</h6>
      </ModalHeader>
      <ModalBody>
        <FallbackRange fallback={fallback} setFallback={setFallback} />
      </ModalBody>
      <ModalFooter className='py-1 border-top'>
        <button className='btn btn-sm btn-soft-info ms-0 me-auto'>Apply to all sizes</button>
        <button className='btn btn-light' onClick={closeModal}>Close</button>
        <button className='btn btn-info' onClick={() => {dispatch(saveFallbackImage(fallback))}}>Save</button>
      </ModalFooter>
    </Modal>
  )
}

export default FallbackImageModal
